import script from "./VehicleTypesTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./VehicleTypesTable.vue?vue&type=script&setup=true&lang=ts"

import "./VehicleTypesTable.vue?vue&type=style&index=0&id=0c94bfa6&lang=sass&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c94bfa6"]])

export default __exports__